/*  
  Developers: Sakshi Bhise  
  File: XSSAllowTags.ts  
  Date: 06/18/2025  
  Project Name: AskHR  
  Team: DSET  
  
  Purpose:  
  Defines the list of safe HTML tags allowed during sanitization to prevent XSS   
  (Cross-Site Scripting) attacks, while enabling essential formatting and media tags   
  for rich content in AskHR components.  
*/  
  
// Allowed HTML tags for content sanitization (for XSS protection)  
export const XSSAllowTags = [  
    'iframe',   // Embedded content  
    'a',        // Links  
    'img',      // Images  
    'svg',      // SVG graphics  
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', // Headings  
    'div',      // Block container  
    'p',        // Paragraph  
    'span',     // Inline container  
    'small',    // Small text  
    'del',      // Deleted text  
    'pictrue',  // (Typo? Should probably be 'picture' for image container)  
    'embed',    // Embedded content  
    'video',    // Video player  
    'audio',    // Audio player  
    'i',        // Italic text  
    'u',        // Underlined text  
    'sup',      // Superscript  
    'sub',      // Subscript  
    'strong',   // Bold text  
    'strike',   // Strikethrough  
    'code',     // Inline code  
    'pre',      // Preformatted block  
    'body',     // Document body  
    'section',  // Section block  
    'article',  // Article block  
    'footer',   // Footer block  
    'table',    // Table container  
    'tr',       // Table row  
    'td',       // Table cell  
    'th',       // Table header cell  
    'thead',    // Table header section  
    'tbody',    // Table body section  
    'tfooter',  // (Typo? Should probably be 'tfoot' for table footer)  
    'ul',       // Unordered list  
    'ol',       // Ordered list  
    'li'        // List item  
  ];  